import React from 'react';
import LogoImage from 'assets/images/logoIcon.png';

class Loading extends React.Component {

    getWindowDimensions() {
        const {innerWidth: width, innerHeight: height} = window;
        return {
            width,
            height
        };
    }

    render() {
        return (
            <div style={{
                textAlign: 'center',
                zIndex: 99999999,
                marginTop: '15%'
            }}>
                <img src={LogoImage} className='animate__animated animate__pulse animate__infinite animate__fast'/>
            </div>
        );
    }
}

export default Loading;